export function getVisibleSettingsTabs({ role, isSuperAdmin, capabilities }) {
  const normalizedRole = String(role || "").toUpperCase();
  if (isSuperAdmin) {
    return ["tenant", "email", "account", "about"];
  }
  if (normalizedRole === "TENANT_ADMIN") {
    return ["tenant", "account", "about"];
  }
  return ["account", "about"];
}

export function getDefaultSettingsTab(visibleTabs) {
  return visibleTabs[0] || "about";
}
